<template>
  <div class="contain">
    <div class="box">
      <div class="">
        <div style="display: flex; align-items: center">
          <img
            src="https://chiness-clothing.oss-cn-beijing.aliyuncs.com/goodsImg/bf84.png"
            mode=""
            style="width: 14px; height: 13px; display: block; margin-right: 5px"
          />
          <div class="shop">
            <span style="vertical-align: middle">{{ storeInfo.storeName }}</span
            ><van-icon
              size="11"
              color="#262626"
              name="arrow"
              style="margin-left: 3px; vertical-align: middle"
            />
          </div>
        </div>
      </div>
      <div style="margin-top: 21px; display: flex; position: relative">
        <!-- src="{{fn.fn(item.goodsImg)[0]}}" -->
        <img
          v-if="details.goodsImg"
          style="
            width: 90px;
            height: 90px;
            border-radius: 5px;
            display: block;
            object-fit: cover;
          "
          mode=""
          :src="details.goodsImg.split(',')[0]"
        />
        <div style="margin-left: 12px">
          <div class="name van-ellipsis--l2" style="margin-top: 4px">
            {{ details.goodsName }}
          </div>
          <!-- {{ storeInfo.integral }} -->
          <div class="price" style="margin-top: 14px">
            <span style="font-size: 11px">￥</span>{{ storeInfo.integral }}
          </div>
          <div
            class="name"
            style="position: absolute; right: 0; top: 50%; font-size: 12px"
          >
            x{{ storeInfo.saleNum }}
          </div>
        </div>
      </div>

      <!-- <div class="date">
        <div>租赁日期</div>
        <div>{{ start }} 至 {{ end }}</div>
      </div> -->
      <!--   -->
      <van-field
        v-model="remark"
        rows="2"
        autosize
        label="留言"
        type="textarea"
        maxlength="90"
        placeholder="请输入留言"
        show-word-limit
      />
    </div>

    <div class="bottom" style="display: flex; justify-content: space-between">
      <div class="price" style="font-size: 15px">
        <span style="font-size: 23px; margin-top: 5px; display: inline-block"
          ><span style="font-size: 15px">￥</span>{{ totalMoney }}</span
        >
      </div>
      <button v-if="!buttonShow" class="button" @click="submit">
        提交订单
      </button>
      <button
        v-else
        class="button"
        type="primary"
        style="background-color: #f4bf418e; color: white"
        loading="true"
        disabled="true"
      >
        提交中...
      </button>
    </div>
  </div>
</template>

<script>
import { getOpenId, getUrl, getPlatform, getIntegral } from "@/utils/auth";
import { Wx_GetHotelRoom } from "@/api/RealInfo";
import { insertOrder } from "@/api/Hotel";
import { Toast } from "vant";
export default {
  // 组件名称
  name: "",
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {
      userName: "",
      remark: "",
      storeInfo: {},
      details: {}, // 商品信息
      totalMoney: "",
      buttonShow: false,
    };
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    // 获取用户信息
    getUserInfo(id) {
      var that = this;
      console.log(getUrl(), 111111111);
      const axios = require("axios");
      const apiUrl = getUrl() + "pointsMall/userInfo";
      const params = { userId: getOpenId() };
      // 发起 GET 请求，并将参数作为查询字符串传递
      axios
        .get(apiUrl, { params })
        .then((response) => {
          // 处理接口返回的数据
          console.log(response.data);
          that.userName = response.data.data.nickName;
        })
        .catch((error) => {
          // 处理错误
          console.error(error);
        });
    },
    // 获取商品详情
    getGoodsInfo() {
      Wx_GetHotelRoom(this.storeInfo.goodsId).then((res) => {
        this.details = res.data.data;
      });
    },

    // 跳转
    gotoUrl(path) {
      if (window.__wxjs_environment === "miniprogram") {
        // 页面 不会重新加载
        window.wx.miniProgram.navigateTo({
          url: "../public/goto?path=" + path,
        });
      } else {
        // 页面会 重新加载(如:列表页 查看详情后会返回顶部)
        this.$router.push(path);
      }
    },
    // 提交订单
    submit() {
      if (getIntegral() < this.totalMoney) {
        Toast.fail("积分不足");
      } else {
        this.buttonShow = true;
        let data = {
          platformId: getPlatform(),
          storeId: this.storeInfo.storeId,
          storeName: this.storeInfo.storeName,
          userId: getOpenId(),
          userName: this.userName,
          totalMoney: this.totalMoney,
          remark: this.remark,
          goodsId: this.storeInfo.goodsId,
          goodsName: this.details.goodsName,
          buyNumber: this.storeInfo.saleNum,
          buyIntegral: this.storeInfo.integral,
        };
        console.log(data, "data");
        insertOrder(data).then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            this.buttonShow = false;
            Toast.success("兑换成功");
            this.updUserIntegral();
            setTimeout(() => {
              this.gotoUrl("/hotels/orderList/1");
            }, 1000);
          }
        });
      }
    },
    // 修改对应项目 积分
    updUserIntegral() {
      var that = this;
      const axios = require("axios");
      const apiUrl = getUrl() + "pointsMall/updUserIntegral";
      const params = { userId: getOpenId(), integral: that.totalMoney };
      // 发起 GET 请求，并将参数作为查询字符串传递
      axios
        .get(apiUrl, { params })
        .then((response) => {
          // 处理接口返回的数据
          console.log(response.data);
          // that.userName = response.data.data.nickName;
        })
        .catch((error) => {
          // 处理错误
          console.error(error);
        });
    },
  },
  created() {
    console.log(this.$route.params);
    this.storeInfo = this.$route.params;
    this.totalMoney = this.storeInfo.saleNum * this.storeInfo.integral;
    this.getUserInfo();
    this.getGoodsInfo();
  },
  mounted() {},
};
</script> 

<style scoped>
.contain {
  min-height: 100vh;
  background-color: #f5f5f5;
  padding-bottom: 50px;
}
/deep/ .van-cell {
  background: #f5f5f5;
  margin-top: 15px;
  border-radius: 5px;
}
.box {
  margin-top: 12px;
  background: #ffffff;
  box-sizing: border-box;
  padding: 22px 18px;
}

.shop {
  background: #f6f6f6;
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 400;
  color: #262626;
}

.name {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #1e1e1e;
}

.price {
  font-size: 17px;
  font-family: PingFang SC;
  color: #ff4d59;
}

.date {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #1e1e1e;
}

.placeholder {
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #bfbfbf;
}

.van-button--danger {
  background: var(--button-danger-background-color, #f26f87) !important;
  border: var(--button-border-width, 1px) solid
    var(--button-danger-border-color, #f26f87) !important;
}

/* 按钮 */
.button {
  width: 30%;
  height: 38px;
  background: #f36e86;
  font-size: 13px;
  font-family: PingFang SC;
  color: #fff;
  border-radius: 19px;
  margin: 0;
  border: none;
}

.bottom {
  width: 100%;
  position: fixed;
  bottom: 0;
  height: 50px;

  background: #ffffff;
  box-shadow: 0px 1px 0px 0px #f6f6f6;
  box-sizing: border-box;
  padding: 5px 11px 6px 19px;
}
.van-ellipsis--l2 {
  display: -webkit-box !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  -webkit-line-clamp: 2 !important;
  -webkit-box-orient: vertical !important;
}
</style>